<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('returnFromVendor.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('returnFromVendor.pageTitle'),
            href: '/admin/return-to-vendors',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-space-y-3">
            <div class="ts-border ts-p-3 ts-rounded">
              <form class="form-horizontal">
                <div class="row">
                  <div class="col-md-6 ts-space-y-3">
                    <div class="row">
                      <label class="col-md-3 col-form-label required">{{
                        $t('returnFromVendor.returnDate')
                      }}</label>
                      <div class="col-md-6">
                        <a-date-picker
                          v-model="model.return_date"
                          format="DD-MM-YYYY"
                          valueFormat="DD-MM-YYYY"
                          class="ts-w-full"
                        ></a-date-picker>
                        <div class="validate" v-if="errors.has('return_date')">
                          {{ errors.first('return_date') }}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-3 col-form-label required">{{
                        $t('returnFromVendor.returnToNumber')
                      }}</label>
                      <div class="col-md-6">
                        <a-select
                          v-model="model.return_to_vendor_id"
                          @change="onFindReturnToVendor"
                          :options="returnToVendorList"
                          showSearch
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          class="ts-w-full"
                        ></a-select>
                        <div class="validate" v-if="errors.has('return_to_vendor_id')">
                          {{ errors.first('return_to_vendor_id') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 ts-space-y-3">
                    <div class="row">
                      <label class="col-md-3 col-form-label">{{
                        $t('returnToVendor.remark')
                      }}</label>
                      <div class="col-md-6">
                        <textarea
                          v-model="model.remarks"
                          rows="3"
                          class="form-control"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="ts-border ts-p-3 ts-rounded">
              <Details v-model="model" :validate="errors"/>
              <div class="validate" v-if="errors.has('product_detail')">
                {{ errors.first('product_detail') }}
              </div>
            </div>
            <div class="ts-flex ts-justify-end ts-space-x-3">
              <ts-button @click.prevent="$router.push({ name: 'return-from-vendor' })">{{ $t('cancel') }}</ts-button>
              <ts-button color="primary"
								:waiting="waiting"
								@click.prevent="save"
							>{{ $t('save') }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import moment from 'moment'
import Details from './component/details.vue'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  name: 'returnToVendorCreate',
  components: {
    Details,
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      waiting: false,
      model: {
        return_date: moment().format('DD-MM-YYYY'),
        return_to_vendor_id: null,
        remarks: null,
        product_detail: [],
      },
    }
  },
  created() {
    this.loading = true
    this.fetchResource().finally(() => (this.loading = false))
  },
  computed: {
    returnToVendorList() {
      return this.$store.state.stock.returnFromVendor.returnToVendor.map((el) => ({
        value: el.return_to_vendor_id,
        label: el.return_number,
      }))
    },
  },
  methods: {
    ...mapActions('stock/returnFromVendor', ['fetchResource', 'store', 'findReturnToVendor']),
    save() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'return-from-vendor' })
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onFindReturnToVendor(value){
      this.loading = true
      this.findReturnToVendor(value)
        .then(response => {
          this.model.product_detail = response.data.details.map(el => ({
            	product_id: el.product_id,
              product_name_en: el.product_name_en,
              uom_id: el.uom_id,
              uom_name_en: el.uom_name_en,
              quantity: el.serials.length ? el.serials.length : el.quantity,
              current_qty: el.current_qty,
              cost: el.cost,
              stock_in_id: el.stock_in_id,
              stock_in_number: el.stock_in_number,
              remarks: el.remarks,
              pro_group_name_en: el.pro_group_name_en,
					    product_type_en: el.product_type_en,
              serials: el.serials.map(el => el.serial_no)
          }))
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
}
</script>